import { createLightTheme, type Theme } from '@fluentui/react-components';
import { opusBrand, RADIOS_OPUS } from './opusNovaDarkTheme.js';

/**
 * Tema light de Fluent v9 con la marca OPUS NOVA.
 * Las marcas brand/accent/semantic son las mismas que el dark — solo cambian
 * los neutrales (surfaces, text, strokes) y el contraste.
 *
 * Se aplica vía <FluentProvider theme={opusNovaLightTheme}> en conjunto con
 * <html data-theme="light"> para sincronizar los CSS vars del design system.
 */
export const opusNovaLightTheme: Theme = {
  ...createLightTheme(opusBrand),

  colorNeutralBackground1: '#ffffff',
  colorNeutralBackground2: '#fafbfd',
  colorNeutralBackground3: '#f1f4f9',
  colorNeutralBackground4: '#e8ecf3',
  colorNeutralBackground1Hover: '#f1f4f9',
  colorNeutralBackground1Pressed: '#e8ecf3',

  colorNeutralForeground1: '#141925',
  colorNeutralForeground2: '#4c576b',
  colorNeutralForeground3: '#828d9f',
  colorNeutralForeground4: '#828d9f',

  colorNeutralStroke1: '#e4e9f1',
  colorNeutralStroke2: '#eef1f6',
  colorNeutralStrokeAccessible: '#cdd5e3',

  // Acento del mockup en claro (#2266dd / hover #1b58c4)
  colorBrandBackground: '#2266dd',
  colorBrandBackgroundHover: '#1b58c4',
  colorBrandBackgroundPressed: '#1b58c4',

  ...RADIOS_OPUS,

  fontFamilyBase: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', 'SF Mono', Consolas, monospace",
};
